<template>
    <div class="wrap">
        <div class="rank_title public_flex_center">
            <span>{{ MIXIN_TEXT[2] }}</span>
        </div>

        <div class="rule_btn public_flex_center" @click="fnGoApp">
            <div class="text public_flex_center">{{ MIXIN_TEXT[71] }}</div>
        </div>

        <Home />
    </div>
</template>
<script lang="ts" setup>
import { watchEffect } from 'vue';
import injectTool from './utils/injectTool';
import Home from './home.vue';

const {TOOL_toast, TOOL_loading, TOOL_TEXT} = injectTool();

// 分享页面中所有按钮点击事件都是此函数 打开app
const fnGoApp = () => {
    window.location.href = `https://sugo.onelink.me/gqNC/8d34d20a?source=invite`
}
//  html title
watchEffect(()=> document.title = TOOL_TEXT[1] || 'Loading...');

</script>
<style lang='scss'>
@use '@page/202411/PreludeRank/scss/public_mixin.scss' as *;
$country: TW, IN, JP, ID;

#root {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: #210746;
}

img {
    // IOS、android 全部禁止选中文本
    user-select: none;
    -webkit-user-select: none;
    // IOS 禁止长摁出现菜单
    -webkit-touch-callout: none;
    // IOS 禁止长摁后图片可拖动
    -webkit-user-drag: none;
}

div::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.wrap {
    position: relative;
    width: 100%;
    min-height: 13.34rem;
    @include bg('page_bg');
    background-size: contain;
    padding: 9.33rem 0 0.48rem;

    .rank_title {
        position: absolute;
        width: 6rem;
        min-height: 0.42rem;
        margin: auto;
        background: linear-gradient(90deg, rgba(175, 2, 255, 0.00) 2.1%, rgba(175, 2, 255, 0.80) 33.14%, rgba(175, 2, 255, 0.80) 64.19%, rgba(175, 2, 255, 0.00) 95.23%);
        top: 3.59rem;
        left: 0;
        right: 0;

        span {
            position: relative;
            color: #FFF9D8;
            font-size: 0.26rem;
            font-weight: 500;

            &::before {
                content: '';
                position: absolute;
                width: 0.62rem;
                height: 0.15rem;
                @include bg('rank_title_dec1');
                left: -0.72rem;
                top: 0;
                bottom: 0;
                margin: auto;
            }

            &::after {
                content: '';
                position: absolute;
                width: 0.62rem;
                height: 0.15rem;
                @include bg('rank_title_dec2');
                right: -0.72rem;
                top: 0;
                bottom: 0;
                margin: auto;
            }
        }
    }

    .rule_btn {
        position: absolute;
        width: 1.86rem;
        height: 0.64rem;
        @include bg('rule');
        top: 8.14rem;
        right: 0;
        text-align: center;

        >div {
            width: 100%;
            height: 100%;
            padding-inline-start: 0.2rem;
            color: #811700;
            text-align: center;
            font-size: 0.24rem;
            font-weight: 700;
        }

        .bg {
            -webkit-text-stroke: #0A237A 4px;
        }

        .text {
            position: absolute;
            z-index: 1;
        }
    }
}

@each $id in $country {
    ##{$id} {
        .wrap {
            @include bg('z_page_bg_' + $id);
            background-size: contain;
        }
    }
}

#EG,
#ME {
    .wrap {
        @include bg('z_page_bg_EG');
        background-size: contain;

        .rule_btn {
            @include bg('rule1');
            right: unset;
            left: 0;
        }
    }
}
</style>
